<mng-dialog-header [title]="data.hotel.name" [iconName]="MGS_HOTEL_ICON" />

<mat-dialog-content>
  <mng-out label="Adresse">
    <div class="text-accent">{{ data.hotel.adresse }}</div>
  </mng-out>

  @if (data.hotel.homepage) {
    <mng-out label="Homepage">
      <a target="_blank" [href]="data.hotel.homepage">{{ data.hotel.homepage }}</a>
    </mng-out>
  }

  @if (data.hotel.telefon) {
    <mng-out label="Telefon">
      <a href="tel:{{ data.hotel.telefon }}">{{ data.hotel.telefon }}</a>
    </mng-out>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Schliessen</button>
</mat-dialog-actions>
